var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDropdownArrowUp = function SvgDropdownArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19301",
    "data-name": "Group 19301",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(7.5 8.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10809",
    "data-name": "Path 10809",
    d: "M0,3.231H0L3.231,0",
    fill: "none",
    stroke: "#07a3c8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1243",
    "data-name": "Line 1243",
    y1: 3.231,
    x2: 3.231,
    transform: "translate(3.231 3.231) rotate(-90)",
    fill: "none",
    stroke: "#07a3c8",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "rectangle-3",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,22A11,11,0,0,0,22,11a11.171,11.171,0,0,0-2.277-6.7A10.84,10.84,0,0,0,11,0a11,11,0,0,0,0,22Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11 21 C 16.5140209197998 21 21 16.5140209197998 21 11 C 21 8.842610359191895 20.29857063293457 6.785920143127441 18.91338920593262 4.884590148925781 C 17.1789608001709 2.488490104675293 14.14671993255615 1 11 1 C 5.485980033874512 1 1 5.485980033874512 1 11 C 1 16.5140209197998 5.485980033874512 21 11 21 M 11 22 C 4.924870014190674 22 -1.77635683940025e-15 17.07513046264648 -1.77635683940025e-15 11 C -1.77635683940025e-15 4.924870014190674 4.924870014190674 -1.77635683940025e-15 11 -1.77635683940025e-15 C 14.66331005096436 -1.77635683940025e-15 17.90838050842285 1.790740013122559 19.72344017028809 4.298230171203613 C 21.22380065917969 6.357649803161621 22 8.588179588317871 22 11 C 22 17.07513046264648 17.07513046264648 22 11 22 Z",
    stroke: "none",
    fill: "#07a3c8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropdownArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdownArrowUp.7777d25b.svg";
export { ForwardRef as ReactComponent };